import { useMemo } from 'react';

import { useUserData } from '~/core/shared/contexts/UserContext';
import { buildCanApi, CanApi } from '~/core/shared/utils/permissions';

/**
 * Permission checks against the current user's grants (auth/me), with
 * backend-identical wildcard semantics (see utils/permissions/matcher.ts).
 *
 * Broker portal surfaces that must also honour brokerage-level grants use
 * useBrokerCan instead.
 */
export const useCan = (): CanApi => {
  const { user } = useUserData();
  const permissions = user?.permissions;

  return useMemo(() => buildCanApi(permissions ?? []), [permissions]);
};
